module.exports = __webpack_public_path__ + "media/images/lb/842-23f5f7cb705554e629385fd599f3462c.svg";